const filters = {
    percent(value) {
        let finalValue = (value && value.cellValue) || value
        finalValue = Number((finalValue * 100).toFixed(2));
        finalValue = isNaN(finalValue) || finalValue === Infinity ? 0 : finalValue;
        return finalValue + '%'
    },
    roi(value) {
        const originValue = (value && value.cellValue) || value
        const finalValue = filters.percent(originValue)
        const style = originValue >= 1 ? 'red' : 'black'
        return `<em class="${style}">${finalValue}</em>`
    },
    price(value) {
        let finalValue = (value && value.cellValue) || value
        finalValue = Number(Number(finalValue).toFixed(2))
        finalValue = isNaN(finalValue) ? 0 : finalValue
        return finalValue
    },
    hourFormat(hour) {
        return hour < 10 ? '0' + hour : hour
    },
    defaultCover(cover) {
        return cover || require('@/assets/imgs/book-cover.jpg')
    }
}

export default filters
